import { ContratoService } from './../contrato.service';
import { Router } from '@angular/router';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from '../../../environments/environment';
import { SegundaViaResponse } from '../../shared/models/segunda-via-response.model';
import { MensagensService } from './../../shared/mensagens/mensagens.service';
import PlanoParcela from 'src/app/shared/models/plano-parcela.model';

@Component({
  selector: 'app-segunda-via',
  templateUrl: './segunda-via.component.html',
  styleUrls: ['./segunda-via.component.scss']
})
export class SegundaViaComponent implements OnInit {

  @Input() showAlert: boolean;
  @Input() dadosSegundaVia: SegundaViaResponse;
  @Output() resetEvent = new EventEmitter<boolean>();
  @Output() downloadBoleto = new EventEmitter<boolean>();
  emotionImage = '../../assets/images/emoticon.svg';
  copiado = false;
  baixado = false;
  banqi = false;

  private hostname = window.location.hostname;

  constructor(
    private mensagens: MensagensService,
    private service: ContratoService
  ) { }

  ngOnInit(): void {
    this.emotionBlink();
    this.banqi = this.showBanqi();
  }

  convertToDatabaseDate(date: string): string {
    if (date) {
      const dateSplit = date.split('-');
      return `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`;
    }
    return null;
  }

  copiarLinhaDigitavel(): void {
    this.copiado = true;
    this.mensagens.sucesso('Linha digitável copiada!');
  }

  baixarBoleto(): void {
    this.baixado = true;
    this.downloadBoleto.next();
  }

  /**
   * Frescurinha no site =D
   */
  private emotionBlink(): void {

    setInterval(() => {
      this.emotionImage = '';
    }, 1500);

    setInterval(() => {
      this.emotionImage = 'wink';
    }, 2500);

  }

  private showBanqi(): boolean {

    if (environment.banqi || this.checkHostName()) {
      return true;
    }

    return false;

  }

  getShowBanqi(): string {
    if (this.banqi) {
      return '60%';
    }

    return '100%';

  }

  private checkHostName(): boolean {
    if (this.hostname) {

      if (this.hostname.indexOf('casasbahia') > 0 || this.hostname.indexOf('cb') > 0) {
        return true;
      }

    }

    return false;
  }

}
